"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
exports.Choice = function (_a) {
    var children = _a.children, correct = _a.correct, name = _a.name;
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.Choice.displayName = "Choice";
